import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAZ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M50 25c0-3.058-.55-5.988-1.555-8.696L25 15.217 1.555 16.304A24.946 24.946 0 0 0 0 25c0 3.058.55 5.987 1.555 8.695L25 34.782l23.445-1.087A24.944 24.944 0 0 0 50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50c10.749 0 19.912-6.784 23.445-16.304H1.555C5.087 43.216 14.25 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M1.555 16.304h46.89C44.912 6.784 35.749 0 25 0 14.25 0 5.087 6.784 1.555 16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25.543 32.065a7.065 7.065 0 1 1 3.361-13.281 8.696 8.696 0 1 0 0 12.432 7.03 7.03 0 0 1-3.36.849Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m30.978 20.108.936 2.632 2.523-1.2-1.2 2.524L35.87 25l-2.632.936 1.2 2.523-2.523-1.2-.936 2.632-.936-2.632-2.523 1.2 1.2-2.523L26.087 25l2.632-.936-1.2-2.523 2.523 1.2.936-2.633Z"
}));
FlagAZ.displayName = 'FlagAZ';
export default withFlagWrapper(FlagAZ);
//# sourceMappingURL=index.js.map